// src/data/exercises/index.js
import catalogEn from "./catalog_en.json";
import catalogUk from "./catalog_uk.json";

export const exercises = catalogEn;
export const exercisesUk = catalogUk;

export function getBaseExercises(lang = "en") {
    return lang === "uk" ? catalogUk : catalogEn;
}

export default exercises;
